import unsorted from "../../assets/design-revamp/default-sort.svg";

const UnsortedIcon = ({ style }) => {
  return (
    <>
      <div>
        <img
          className=""
          src={unsorted}
          alt=""
          style={{ ...style, width: "20px", height: "20px" }}
        />
      </div>
    </>
  );
};

export default UnsortedIcon;
